import React from 'react';

// 组件导入
import Overview from "@containers/facility/Overview/Overview";
import Equipment from "@containers/facility/Equipment/Equipment";
import FunctionalTesting from "@containers/facility/Equipment/FunctionalTesting/FunctionalTesting";
import FunctionalTestingDetail from "@containers/facility/Equipment/FunctionalTesting/detail";
import EquipmentDetail from '@/containers/facility/Equipment/detail';
import Workorder from "@containers/facility/Workorder/Workorder";

// v2.0 CMMS 组件导入
import PMPlan from "@containers/facility/PM/PMPlan/PMPlan";
import PMPlanDetail from "@containers/facility/PM/PMPlan/PMPlanDetail";
import WorkorderWrapperPage from "@containers/facility/WorkorderWrapper/WorkorderWrapper";
import WorkorderWrapperDetail from "@containers/facility/WorkorderWrapper/WorkorderWrapperDetail";
import Benchmark, { BenchmarkLegacyRedirect } from "@/containers/facility/Benchmark/Benchmark";
import FAQ from "@containers/Help/FAQ";
import Profile from "@containers/facility/Profile/Profile";
import Project from "@containers/facility/ProjectManagement/Project/Project";
import ProjectDetail from '@/containers/facility/ProjectManagement/detail';
import StationTemperature from "@containers/facility/StationTemperature/StationTemperature";
import Scenario from "@containers/facility/Scenario/Scenario";
import Log from "@containers/UtilityData/Log/Log";
import Report from "@containers/Report";
import NotificationDetail from "@containers/facility/Notification/NotificationDetail";
import AllComments from "@containers/facility/Comments/AllComments";
import FileManage from "@containers/FileManage";
import FileSearchResultView from "@containers/FileManage/FileSearchResultView";
import NewSummary from "@containers/UtilityData/New-Summary";
import GasPage from "@containers/UtilityData/GasPage";
import ElectricityPage from "@containers/UtilityData/ElectricityPage";
import WaterPage from "@containers/UtilityData/WaterPage";
import SavingsPage from "@/containers/UtilityData/SavingsPage";
import TagManage from "@/containers/Tags/TagManage";
import { ElecDetail } from "@/containers/UtilityData/Eletricity/ElecDetail";
import { GasDetail } from "@/containers/UtilityData/Gas/GasDetail";
import { WaterDetail } from "@/containers/UtilityData/Water/WaterDetail";
import Certify from "@/containers/Utility/Certify";

// Company/Admin 组件导入
import Facility from '@/containers/management/Facility/Facility';
import FacilityDetail from '@/containers/management/Facility/detail';
import EquipmentCategory from '@/containers/facility/Equipment_Category/Equipment_Category';
import Company from '@/containers/management/Company/Company';
import CompanyDetail from '@/containers/management/Company/detail';
import CustomUser from "@containers/management/UserManagement/CustomUser/CustomUser";
import UserProfile from "@containers/management/UserManagement/Profile/Profile";
import Role from "@containers/management/UserManagement/Role/Role";
import FunctionalForm from '@/containers/management/FunctionalForm/FunctionalForm';
import EquipmentCategoryTemplate from '@/containers/management/EquipmentCategoryTemplate/EquipmentCategoryTemplate';
import ServiceCategory from '@/containers/management/ServiceCategory/ServiceCategory';
import UserDetail from '@/containers/management/UserManagement/UserDetail';
import CreateUser from '@/containers/management/UserManagement/CreateUser';
import InviteUser from '@/containers/management/UserManagement/InviteUser';
import { CertifyRequest } from '@/containers/Admin/CertifyRequest';

// Portfolio 组件导入
import PortfolioManage from "@containers/PortfolioManage/Dashboard";

// 内部错误页面组件导入
import InternalNotFound from "@/components/InternalErrorPages/InternalNotFound";
import InternalForbidden from "@/components/InternalErrorPages/InternalForbidden";
import SearchResultsTable from "@containers/SearchResultsTable/SearchResultsTable";
import AdminSettings from '@/containers/Admin/settings';
import WorkorderDetail from '@/containers/facility/Workorder/detail';
import Facility_Category from '@/containers/facility/Facility_Category/Facility_Category';
import CertifyPage from '@/containers/Utility/certify-new';
import AdminBenchmark from '@/containers/Admin/admin-benchmark';
import EquipmentCategoryDetail from '@/containers/facility/Equipment_Category/detail';
import FacilityCategoryDetail from '@/containers/facility/Facility_Category/detail';
import FunctionalFormDetail from '@/containers/management/FunctionalForm/detail';
import EquipmentCategoryTemplateDetail from '@/containers/management/EquipmentCategoryTemplate/detail';
import ServiceCategoryDetail from '@/containers/management/ServiceCategory/detail';
import { buildPathFromConfigPath, getContextualRoutePattern } from '@/utils/route-context';

export const routeConfig = {
  facility: [
    {
      path: "/facility/dashboard",
      component: <Overview />,
      title: "Dashboard",
      icon: <span className="fas fa-home"></span>,
      code: "dashboard_menu"
    },
    {
      path: "/facility/profile",
      component: <Profile />,
      title: "Profile",
      code: "profile",
      hideInMenu: true
    },

    {
      key: "UtilitySummary",
      title: "Utility Data",
      code: "utility_menu",
      icon: <span className="fas fa-charging-station"></span>,
      children: [
        {
          path: "/facility/utility-summary",
          component: <NewSummary />,
          title: "Summary",
          code: "summary_menu"
        },
        {
          path: "/facility/electricity",
          component: <ElectricityPage />,
          title: "Electricity",
          code: "electricity"
        },
        {
          path: "/facility/gas",
          component: <GasPage />,
          title: "Gas",
          code: "gas"
        },
        {
          path: "/facility/water",
          component: <WaterPage />,
          title: "Water",
          code: "water"
        },
        {
          path: "/facility/savings",
          component: <SavingsPage />,
          title: "Savings",
          code: "savings_menu"
        },
        // {
        //   path: "/facility/certify",
        //   component: <Certify />,
        //   title: "Certify",
        //   code: "certify_menu"
        // },
        {
          path: "/facility/certify",
          component: <CertifyPage />,
          title: "Certify",
          code: "certify_menu"
        },
      ]
    },
    {
      path: "/facility/benchmark",
      component: <Benchmark />,
      title: "Benchmark",
      code: "benchmark",
      icon: <span className="fas fa-chart-bar"></span>
    },
    {
      path: "/facility/inter-company-benchmark",
      component: <BenchmarkLegacyRedirect tab="inter-company" />,
      title: "Inter-company Benchmark",
      code: "benchmark",
      hideInMenu: true
    },
    {
      path: "/facility/all-facility-benchmark",
      component: <BenchmarkLegacyRedirect tab="all-facility" />,
      title: "All Facility Benchmark",
      code: "benchmark",
      hideInMenu: true
    },
    {
      path: "/facility/national-benchmark",
      component: <BenchmarkLegacyRedirect tab="national" />,
      title: "National Benchmark",
      code: "benchmark",
      hideInMenu: true
    },
    {
      path: "/facility/workorder",
      component: <Workorder />,
      title: "Work Order",
      code: "workorder",
      icon: <span className="fas fa-tools"></span>
    },
    {
      path: "/facility/workorder-detail/:id",
      component: <WorkorderDetail />,
      title: "Work Order Detail",
      code: "workorder",
      hideInMenu: true
    },
    {
      path: "/facility/create-workorder",
      component: <WorkorderDetail isAdd={true} />,
      title: "Create Work Order",
      code: "workorder",
      hideInMenu: true
    },
    {
      path: "/facility/search/workorder",
      component: <Workorder />,
      title: "Search result",
      code: "workorder_menu",
      icon: <span className="fas fa-tools"></span>,
      hideInMenu: true
    },
    {
      title: "Equipment",
      code: "equipment_folder_menu",
      icon: <span className="fas fa-cogs"></span>,
      children: [
        {
          path: "/facility/equipment",
          component: <Equipment />,
          title: "Equipment",
          code: "equipment"
        },
        {
          path: "/facility/equipment-detail/:id",
          component: <EquipmentDetail />,
          title: "Equipment Detail",
          code: "equipment",
          hideInMenu: true
        },
        {
          path: "/facility/create-equipment",
          component: <EquipmentDetail isAdd={true} />,
          title: "Create Equipment",
          code: "equipment",
          hideInMenu: true
        },
        {
          path: "/facility/search/equipment",
          component: <Equipment />,
          title: "Search result",
          code: "equipment",
          hideInMenu: true
        },
        {
          path: "/facility/Forms",
          component: <FunctionalTesting />,
          title: "Forms",
          code: "functiontesting"
        },
        {
          path: "/facility/functional-testing",
          component: <FunctionalTesting />,
          title: "Forms",
          code: "functiontesting",
          hideInMenu: true
        },
        {
          path: "/facility/forms-detail/:id",
          component: <FunctionalTestingDetail />,
          title: "Form Details",
          code: "functiontesting",
          hideInMenu: true
        },
        {
          path: "/facility/functional-testing-detail/:id",
          component: <FunctionalTestingDetail />,
          title: "Form Details",
          code: "functiontesting",
          hideInMenu: true
        },
        {
          path: "/facility/create-functional-testing",
          component: <FunctionalTestingDetail isAdd={true} />,
          title: "Create Functional Testing",
          code: "functiontesting",
          hideInMenu: true
        },
        {
          path: "/facility/search/functional-testing",
          component: <FunctionalTesting />,
          title: "Search result",
          code: "functiontesting",
          hideInMenu: true
        },
        {
          path: "/facility/pm-plan",
          component: <PMPlan />,
          title: "Preventive Maintenance",
          code: "equipment",
        },
        {
          path: "/facility/pm-plan-detail/:id",
          component: <PMPlanDetail />,
          title: "Preventive Maintenance Detail",
          code: "equipment",
          hideInMenu: true,
        },
        {
          path: "/facility/create-pm-plan",
          component: <PMPlanDetail isAdd={true} />,
          title: "Create Preventive Maintenance",
          code: "equipment",
          hideInMenu: true,
        },
      ]
    },

    // v2.0 CMMS - Workorder Wrapper 路由（不在侧栏显示；通过 Workorder 列表展开分组访问）
    {
      path: "/facility/workorder-wrapper",
      component: <WorkorderWrapperPage />,
      title: "Workorder Wrappers",
      code: "workorder",
      icon: <span className="fas fa-layer-group"></span>,
      hideInMenu: true,
    },
    {
      path: "/facility/workorder-wrapper-detail/:id",
      component: <WorkorderWrapperDetail />,
      title: "Workorder Wrapper Detail",
      code: "workorder",
      hideInMenu: true,
    },
    {
      path: "/facility/create-workorder-wrapper",
      component: <WorkorderWrapperDetail isAdd={true} />,
      title: "Create Workorder Wrapper",
      code: "workorder",
      hideInMenu: true,
    },

    {
      path: "/facility/project",
      component: <Project />,
      title: "Project",
      code: "planning",
      icon: <span className="fas fa-calendar-check"></span>
    },
    {
      path: "/facility/project-detail/:id",
      component: <ProjectDetail />,
      title: "Project Detail",
      code: "planning",
      hideInMenu: true
    },
    {
      path: "/facility/create-project",
      component: <ProjectDetail isAdd={true} />,
      title: "Create Project",
      code: "planning",
      hideInMenu: true
    },
    {
      path: "/facility/notification",
      component: <NotificationDetail />,
      title: "Notification",
      code: "notification",
      icon: <span className="fa-solid fa-bell"></span>
    },
    {
      path: "/facility/search/notification",
      component: <NotificationDetail />,
      title: "Search result",
      code: "notification",
      icon: <span className="fa-solid fa-bell"></span>,
      hideInMenu: true
    },
    {
      path: "/facility/log",
      component: <Log />,
      title: "Log",
      code: "log",
      icon: <span className="fa-solid fa-file-alt"></span>
    },
    {
      path: "/facility/report",
      component: <Report />,
      title: "Report",
      code: "customreport",
      icon: <span className="fas fa-file-pdf"></span>
    },
    {
      path: "/facility/file-manage",
      component: <FileManage />,
      title: "File Manage",
      code: "filemanage",
      icon: <span className="fas fa-file"></span>
    },
    {
      path: "/facility/search/file-manage",
      component: <FileSearchResultView />,
      title: "Search result",
      code: "filemanage",
      icon: <span className="fas fa-file"></span>,
      hideInMenu: true
    },
    {
      path: "/facility/comments",
      component: <AllComments />,
      title: "Comments",
      code: "comments",
      hideInMenu: true
    },
    // 详情页路由
    {
      path: "/facility/create-gas",
      component: <GasDetail isAdd={true} />,
      title: "Create Gas",
      code: "gas",
      hideInMenu: true
    },
    {
      path: "/facility/gas-detail/:id",
      component: <GasDetail />,
      title: "Gas Detail",
      code: "gas",
      hideInMenu: true
    },
    {
      path: "/facility/create-electricity",
      component: <ElecDetail isAdd={true} />,
      title: "Create Electricity",
      code: "electricity",
      hideInMenu: true
    },
    {
      path: "/facility/elec-detail/:id",
      component: <ElecDetail />,
      title: "Electricity Detail",
      code: "electricity",
      hideInMenu: true
    },
    {
      path: "/facility/create-water",
      component: <WaterDetail isAdd={true} />,
      title: "Create Water",
      code: "water",
      hideInMenu: true
    },
    {
      path: "/facility/water-detail/:id",
      component: <WaterDetail />,
      title: "Water Detail",
      code: "water",
      hideInMenu: true
    },
    // 内部错误页面
    {
      path: "/facility/404",
      component: <InternalNotFound />,
      title: "Page Not Found",
      hideInMenu: true
    },
    {
      path: "/facility/403",
      component: <InternalForbidden />,
      title: "Access Forbidden",
      hideInMenu: true
    }
  ],

  admin: [
    {
      path: "/admin/user-management",
      component: <CustomUser />,
      title: "User",
      code: "user",
      icon: <span className='fa fa-user'></span>
    },
    // {
    //   path: "/admin/profile-management",
    //   component: <UserProfile />,
    //   title: "Permission Profile",
    //   code: "profile_menu",
    //   icon: <span className='fas fa-user-shield'></span>
    // },
    {
      path: "/admin/profile-management",
      component: <Role />,
      title: "Profile Management",
      code: "role_menu",
      icon: <span className='fas fa-user-cog'></span>
    },
    {
      path: "/admin/company",
      component: <Company />,
      title: "Company",
      code: "company",
      icon: <span className='fas fa-building'></span>
    },
    {
      path: "/admin/company-detail/:id",
      component: <CompanyDetail />,
      title: "Company Detail",
      code: "company",
      hideInMenu: true
    },
    {
      path: "/admin/create-company",
      component: <CompanyDetail isAdd={true} />,
      title: "Create Company",
      code: "company",
      hideInMenu: true
    },
    //here
    {
      path: "/admin/facility",
      component: <Facility />,
      title: "Facility",
      code: "facility",
      icon: <span className='fas fa-sitemap'></span>
    },
    {
      path: "/admin/facility-detail/:id",
      component: <FacilityDetail />,
      title: "Facility Detail",
      code: "facility",
      hideInMenu: true
    },
    {
      path: "/admin/create-facility",
      component: <FacilityDetail isAdd={true} />,
      title: "Create Facility",
      code: "facility",
      hideInMenu: true
    },
    {
      key: "Template",
      title: "Template",
      code: "admin_template_menu",
      icon: <span className="fas fa-file-alt"></span>,
      children: [
        {
          path: "/admin/equipment-category",
          component: <EquipmentCategory />,
          title: "Equipment Category",
          code: "equipmentCategory",
          icon: <span className='fas fa-th-list'></span>
        },
        {
          path: "/admin/equipment-category-detail/:id",
          component: <EquipmentCategoryDetail />,
          title: "Equipment Category Detail",
          code: "equipmentCategory",
          hideInMenu: true
        },
        {
          path: "/admin/create-equipment-category",
          component: <EquipmentCategoryDetail isAdd={true} />,
          title: "Create Equipment Category",
          code: "equipmentCategory",
          hideInMenu: true
        },
        {
          path: "/admin/equipment-category-template",
          component: <EquipmentCategoryTemplate />,
          title: "Equipment Category Template",
          code: "equipmentCategoryTemplate",
          icon: <span className='fas fa-table-list'></span>
        },
        {
          path: "/admin/equipment-category-template-detail/:id",
          component: <EquipmentCategoryTemplateDetail />,
          title: "Equipment Category Template Detail",
          code: "equipmentCategoryTemplate",
          hideInMenu: true
        },
        {
          path: "/admin/create-equipment-category-template",
          component: <EquipmentCategoryTemplateDetail isAdd={true} />,
          title: "Create Equipment Category Template",
          code: "equipmentCategoryTemplate",
          hideInMenu: true
        },
        {
          path: "/admin/facility-category",
          component: <Facility_Category />,
          title: "Facility Category",
          code: "FacilityCategory",
          icon: <span className='fas fa-layer-group'></span>
        },
        {
          path: "/admin/facility-category-detail/:id",
          component: <FacilityCategoryDetail />,
          title: "Facility Category Detail",
          code: "FacilityCategory",
          hideInMenu: true
        },
        {
          path: "/admin/service-category",
          component: <ServiceCategory />,
          title: "Service Category",
          code: "serviceCategory",
          icon: <span className='fas fa-list-check'></span>
        },
        {
          path: "/admin/service-category-detail/:id",
          component: <ServiceCategoryDetail />,
          title: "Service Category Detail",
          code: "serviceCategory",
          hideInMenu: true
        },
        {
          path: "/admin/create-service-category",
          component: <ServiceCategoryDetail isAdd={true} />,
          title: "Create Service Category",
          code: "serviceCategory",
          hideInMenu: true
        },
        {
          path: "/admin/forms",
          component: <FunctionalForm />,
          title: "Forms",
          code: "functionform",
          icon: <span className='fab fa-wpforms'></span>
        },
        {
          path: "/admin/forms-detail/:id",
          component: <FunctionalFormDetail />,
          title: "Form Details",
          code: "functionform",
          hideInMenu: true
        },
        {
          path: "/admin/create-form",
          component: <FunctionalFormDetail isAdd={true} />,
          title: "Create Form",
          code: "functionform",
          hideInMenu: true
        },
      ]
    },
    {
      path: "/admin/settings",
      component: <AdminSettings />,
      title: "Settings",
      code: "admin_settings_menu",
      icon: <span className="fas fa-cog"></span>
    },
    {
      path: "/admin/certify-request",
      component: <CertifyRequest />,
      title: "Certify Request",
      code: "certify_request_menu",
      icon: <span className='fas fa-certificate'></span>
    },
    {
      path: "/admin/benchmark",
      component: <AdminBenchmark />,
      title: "Benchmark",
      code: "admin_benchmark_menu",
      icon: <span className='fas fa-chart-line'></span>
    },
    {
      path: "/admin/tags",
      component: <TagManage />,
      title: "Tags",
      code: "tags",
      icon: <span className="fas fa-tag"></span>
    },
    // 详情页路由
    {
      path: "/admin/user-detail/:id",
      component: <UserDetail />,
      title: "User Detail",
      code: "user",
      hideInMenu: true
    },
    {
      path: "/admin/create-user",
      component: <CreateUser />,
      title: "Create User",
      code: "user_create_feature",
      hideInMenu: true
    },
    {
      path: "/admin/invite-user",
      component: <InviteUser />,
      title: "Invite User",
      code: "user_create_feature", 
      hideInMenu: true
    },
    // 内部错误页面
    {
      path: "/admin/404",
      component: <InternalNotFound />,
      title: "Page Not Found",
      hideInMenu: true
    },
    {
      path: "/admin/403",
      component: <InternalForbidden />,
      title: "Access Forbidden",
      hideInMenu: true
    }
  ],

  portfolio: [
    {
      path: "/portfolio/dashboard",
      component: <PortfolioManage />,
      title: "Portfolio Dashboard",
      code: "portfolio_dashboard_menu",
      icon: <i className="fas fa-chart-line" />
    },
    // 内部错误页面
    {
      path: "/portfolio/404",
      component: <InternalNotFound />,
      title: "Page Not Found",
      hideInMenu: true
    },
    {
      path: "/portfolio/403",
      component: <InternalForbidden />,
      title: "Access Forbidden",
      hideInMenu: true
    }
  ],
  common: [
    {
      path: "/common/notification",
      component: <NotificationDetail />,
      title: "Notification",
      code: "notification",
      icon: <span className="fa-solid fa-bell"></span>
    },
    {
      path: "/common/search-result",
      component: <SearchResultsTable />,
      title: "Search Results",
      code: "search-result",
      icon: <span className="fa-solid fa-search"></span>
    },
  ]
};

// 视图模式映射
export const VIEW_MODE_MAP = {
  0: 'facility',
  1: 'admin', 
  2: 'portfolio'
};

// 权限代码映射到视图权限
export const PERMISSION_VIEW_MAP = {
  facility: 'facility_view',
  admin: 'admin_view',
  portfolio: 'portfolio_view'
};

// 获取扁平化的路由列表
export const getFlatRoutes = (viewType) => {
  const routes = routeConfig[viewType] || [];
  const flatRoutes = [];

  const traverse = (items) => {
    items.forEach(item => {
      if (item.path) {
        flatRoutes.push({
          ...item,
          legacyPath: item.path,
          path: getContextualRoutePattern(item.path, viewType),
        });
      }
      if (item.children) {
        traverse(item.children);
      }
    });
  };

  traverse(routes);
  return flatRoutes;
};

export const getLegacyFlatRoutes = (viewType) => {
  const routes = routeConfig[viewType] || [];
  const flatRoutes = [];

  const traverse = (items) => {
    items.forEach(item => {
      if (item.path) {
        flatRoutes.push({
          ...item,
          legacyPath: item.path,
        });
      }
      if (item.children) {
        traverse(item.children);
      }
    });
  };

  traverse(routes);
  return flatRoutes;
};

// 获取菜单项（递归过滤掉所有层级的hideInMenu项目）
export const getMenuItems = (viewType) => {
  const routes = routeConfig[viewType] || [];
  
  const filterMenuItems = (items) => {
    return items
      .filter(item => !item.hideInMenu)
      .map(item => {
        if (item.children) {
          return {
            ...item,
            children: filterMenuItems(item.children)
          };
        }
        return item;
      });
  };
  
  return filterMenuItems(routes);
}; 

export const getMenuItemsWithContext = (viewType, context = {}) => {
  const routes = getMenuItems(viewType);

  const mapItems = (items) => {
    return items.map((item) => {
      const nextItem = {
        ...item,
      };

      if (item.path) {
        nextItem.legacyPath = item.path;
        nextItem.path = buildPathFromConfigPath(item.path, viewType, context);
      }

      if (item.children) {
        nextItem.children = mapItems(item.children);
      }

      return nextItem;
    });
  };

  return mapItems(routes);
};
